import placeholderImage from '@cannect/assets/img/categoryCard/all.png'
import disfuncaoEretil from '@cannect/assets/img/subcategories/disfuncao-eretil-1.webp'
import doencasCronicas from '@cannect/assets/img/subcategories/doencas-cronicas.webp'
import dorFebre from '@cannect/assets/img/subcategories/dor-febre.webp'
import gripesResfriados from '@cannect/assets/img/subcategories/gripes-resfriados.webp'
import higieneBeleza from '@cannect/assets/img/subcategories/higiene-beleza.webp'
import mamaeEBebe from '@cannect/assets/img/subcategories/mamae-e-bebe.webp'
import perdaDePeso from '@cannect/assets/img/subcategories/perda-de-peso.webp'
import quedaDeCabelo from '@cannect/assets/img/subcategories/queda-de-cabelo.webp'
import saudeMentalBemEstar from '@cannect/assets/img/subcategories/saude-mental-bem-estar.webp'
import vitaminasSuplementos from '@cannect/assets/img/subcategories/vitaminas-suplementos.webp'

export const SUBCATEGORY_IMAGE_MAP: Record<string, string> = {
  'disfuncao-eretil-1': disfuncaoEretil,
  'doencas-cronicas': doencasCronicas,
  'dor-febre': dorFebre,
  'gripes-resfriados': gripesResfriados,
  'higiene-beleza': higieneBeleza,
  'mamae-e-bebe': mamaeEBebe,
  'perda-de-peso': perdaDePeso,
  'queda-de-cabelo': quedaDeCabelo,
  'saude-mental-bem-estar': saudeMentalBemEstar,
  'vitaminas-suplementos': vitaminasSuplementos
}

export const DEFAULT_SUBCATEGORY_IMAGE = placeholderImage
